import { RootActions, RootState } from "common/reducers";
import { Map, Record } from "immutable";
import { RECEIVE_JOB_STATE_LOG, RECEIVE_JOB_STATE_LOGS } from "common/reducers/jobStateLog.actions";
import { jobStateLogFromJSON, JobStateLogRecord } from "common/records/JobStateLog";
import { JobStateLogActions } from "common/reducers/jobStateLog.actions";
import { receive } from "common/reducers/Utils";

export const JobStateLogStateRecord = Record({
  byId: Map<number, JobStateLogRecord>(),
  lastSavedById: Map<number, JobStateLogRecord>(),
});

export const initialState = JobStateLogStateRecord();
export type JobStateLogState = typeof initialState;
export const model = "jobStateLogs";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_JOB_STATE_LOG:
      return receive(state, model, jobStateLogFromJSON(action.payload.stateLog)) as RootState;

    case RECEIVE_JOB_STATE_LOGS:
      action.payload.stateLogs.forEach((s) => {
        state = reducer(state, JobStateLogActions.receiveJobStateLog(s));
      });

      return state;

    default:
      return state;
  }
};
